module.exports = __webpack_public_path__ + "static/media/activeSettings.285ea14e.svg";